<template>
  <svg id="Coupe" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width"
    :height="height" viewBox="0 0 44.191 18.475">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_9953" data-name="Rectangle 9953" :width="width" :height="height" :fill="themeColor" />
      </clipPath>
    </defs>
    <g id="Group_25371" data-name="Group 25371" transform="translate(0 0)" clip-path="url(#clip-path)">
      <path id="Path_86932" data-name="Path 86932"
        d="M96.946,37.546a4.028,4.028,0,1,0-4.028-4.028,4.028,4.028,0,0,0,4.028,4.028m0-6.232a2.2,2.2,0,1,1-2.205,2.205,2.2,2.2,0,0,1,2.205-2.205"
        transform="translate(-60.087 -19.071)" :fill="themeColor" />
      <path id="Path_86933" data-name="Path 86933"
        d="M25.192,37.546a4.028,4.028,0,1,0-4.028-4.028,4.028,4.028,0,0,0,4.028,4.028m0-6.232a2.2,2.2,0,1,1-2.2,2.205,2.2,2.2,0,0,1,2.2-2.205"
        transform="translate(-13.686 -19.071)" :fill="themeColor" />
      <path id="Path_86934" data-name="Path 86934"
        d="M3.755,15.147h1.6a.911.911,0,0,0,.036-1.822H3.755c-.675,0-1.449-.925-1.89-2.232L3.239,6.341l4.055-.512a.911.911,0,0,0,.514-.244l3.5-3.332c1.864-.207,7.823-1.215,12.412.854a.855.855,0,0,0,.1.039,49.122,49.122,0,0,1,6.085,2.719c.977.488,1.821.908,2.456,1.187A20.558,20.558,0,0,0,35.832,8a15.479,15.479,0,0,1,4.529,1.417c1.04.731,1.791,3.425,2.021,4.952a.911.911,0,0,0,1.8-.269c-.071-.483-.761-4.757-2.775-6.173a15.881,15.881,0,0,0-5.188-1.707,19.728,19.728,0,0,1-3.127-.838c-.594-.261-1.42-.671-2.375-1.149a51.11,51.11,0,0,0-6.3-2.81C18.893-1.026,11.289.416,10.786.479a.914.914,0,0,0-.515.244l-3.5,3.335-4.352.549a.911.911,0,0,0-.761.651L.037,10.851a.918.918,0,0,0,0,.511c.689,2.334,2.113,3.785,3.715,3.785"
        transform="translate(0 -0.001)" :fill="themeColor" />
      <path id="Path_86935" data-name="Path 86935"
        d="M48.465,39.534H61.311a.911.911,0,1,0,.036-1.822H48.465a.911.911,0,0,0-.036,1.822h.036"
        transform="translate(-30.74 -24.387)" :fill="themeColor" />
      <path id="Path_86936" data-name="Path 86936"
        d="M58.738,18a.911.911,0,0,0,0-1.822L38.776,16.06h0a.911.911,0,0,0,0,1.822L58.734,18Z"
        transform="translate(-24.494 -10.386)" :fill="themeColor" />
    </g>
  </svg>
</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
